/* Royaltubs Theme JS */
(function () {
  'use strict';

  // Mark <html> so CSS knows JS is alive and it's safe to hide .r elements
  // until the IntersectionObserver reveals them. If JS fails, .r stays visible.
  document.documentElement.classList.add('js-reveal');

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // --- Mobile menu toggle ---
    var menuBtn = document.querySelector('.mobile-menu-btn');
    var mobileMenu = document.querySelector('.mobile-menu');
    if (menuBtn && mobileMenu) {
      menuBtn.addEventListener('click', function () {
        mobileMenu.classList.toggle('open');
      });
    }

    // --- Scroll reveal (.r -> .r.v) ---
    var revealEls = document.querySelectorAll('.r');

    // Safety: if IntersectionObserver is unsupported OR user prefers reduced motion,
    // reveal everything immediately so content is never stuck hidden.
    var prefersReduced =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!('IntersectionObserver' in window) || prefersReduced) {
      for (var i = 0; i < revealEls.length; i++) revealEls[i].classList.add('v');
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('v');
            io.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
    );

    revealEls.forEach(function (el) {
      // If element is already in viewport on load, reveal immediately
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        el.classList.add('v');
      } else {
        io.observe(el);
      }
    });

    // Final safety net: after 2s, reveal anything still hidden (prevents
    // content ever being permanently invisible if observer misses it).
    setTimeout(function () {
      document.querySelectorAll('.r:not(.v)').forEach(function (el) {
        el.classList.add('v');
      });
    }, 2000);

    // --- Live lager-counter (countdown scarcity) ---
    // Persistent across page visits via localStorage. Starts at MAX (9),
    // decrements every 60-180s randomly, never goes below MIN (3).
    (function lagerCounter() {
      var counters = document.querySelectorAll('[data-lager-counter]');
      if (!counters.length) return;

      var KEY = 'rt_lager_state';
      var MIN = 3;
      var MAX = 9;
      var TICK_MIN_MS = 60 * 1000;   // 1 min
      var TICK_MAX_MS = 180 * 1000;  // 3 min

      function nextTickAt() {
        return Date.now() + TICK_MIN_MS + Math.random() * (TICK_MAX_MS - TICK_MIN_MS);
      }

      function load() {
        try {
          var s = JSON.parse(localStorage.getItem(KEY) || 'null');
          if (s && typeof s.value === 'number' && typeof s.nextAt === 'number') return s;
        } catch (e) {}
        return null;
      }
      function save(s) {
        try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
      }

      var state = load();
      if (!state) state = { value: MAX, nextAt: nextTickAt() };

      // Catch-up: replay missed decrements since last visit
      while (Date.now() >= state.nextAt && state.value > MIN) {
        state.value -= 1;
        state.nextAt = nextTickAt();
      }
      save(state);

      function render(flash) {
        counters.forEach(function (el) {
          el.textContent = state.value;
          if (flash) {
            el.classList.remove('lager-flash');
            void el.offsetWidth; // restart animation
            el.classList.add('lager-flash');
            setTimeout(function () { el.classList.remove('lager-flash'); }, 1400);
            // Shake the parent pill if present
            var pill = el.closest('.lager-counter-pill');
            if (pill) {
              pill.classList.remove('lager-pill-shake');
              void pill.offsetWidth;
              pill.classList.add('lager-pill-shake');
              setTimeout(function () { pill.classList.remove('lager-pill-shake'); }, 550);
            }
          }
        });
      }

      render(false);

      function tick() {
        var delay = Math.max(2000, state.nextAt - Date.now());
        setTimeout(function () {
          if (state.value > MIN) {
            state.value -= 1;
            state.nextAt = nextTickAt();
            save(state);
            render(true);
          } else {
            state.nextAt = nextTickAt();
            save(state);
          }
          tick();
        }, delay);
      }
      tick();
    })();

    // --- Social proof sales counter (counts UP) ---
    // Persistent counter — counts upward from 2 to 8, increments every 2-6 min,
    // cycles back to 2 after hitting 8 to keep feeling fresh.
    (function salesCounter() {
      var els = document.querySelectorAll('[data-sales-counter]');
      if (!els.length) return;

      var KEY = 'rt_sales_state';
      var MIN = 2;
      var MAX = 8;
      var TICK_MIN = 120 * 1000;  // 2 min
      var TICK_MAX = 360 * 1000;  // 6 min

      function nextAt() {
        return Date.now() + TICK_MIN + Math.random() * (TICK_MAX - TICK_MIN);
      }
      function load() {
        try {
          var s = JSON.parse(localStorage.getItem(KEY) || 'null');
          if (s && typeof s.value === 'number' && typeof s.nextAt === 'number') return s;
        } catch (e) {}
        return null;
      }
      function save(s) { try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }

      var state = load();
      if (!state) state = { value: MIN + Math.floor(Math.random() * 2), nextAt: nextAt() }; // 2 or 3

      // Catch-up: replay missed increments
      while (Date.now() >= state.nextAt) {
        state.value = state.value >= MAX ? MIN : state.value + 1;
        state.nextAt = nextAt();
      }
      save(state);

      function render(flash) {
        els.forEach(function (el) {
          el.textContent = state.value;
          if (flash) {
            el.classList.remove('sales-flash');
            void el.offsetWidth;
            el.classList.add('sales-flash');
            setTimeout(function () { el.classList.remove('sales-flash'); }, 1200);
            var box = el.closest('.product-info__social');
            if (box) {
              box.classList.remove('sales-bump');
              void box.offsetWidth;
              box.classList.add('sales-bump');
              setTimeout(function () { box.classList.remove('sales-bump'); }, 700);
            }
          }
        });
      }
      render(false);

      function tick() {
        var delay = Math.max(2000, state.nextAt - Date.now());
        setTimeout(function () {
          state.value = state.value >= MAX ? MIN : state.value + 1;
          state.nextAt = nextAt();
          save(state);
          render(true);
          tick();
        }, delay);
      }
      tick();
    })();
  });
})();
